import {Viewport} from '@att-bit/duc.hooks.use-viewport';
export { useWindowSize, Orientation } from './use-window-size';
export type { IUseWindowSize } from './use-window-size';
export {Viewport, Viewport as ViewPort}
